import * as React from 'react';
import { Path } from '../..';
import s from './menu-item.scss';
import { Box, CounterBadge, SidebarDivider, SidebarSectionItem, } from 'wix-style-react';
import { AppMarketLink } from '../app-market-link';
import { composer } from '../../component-decorators/composer';
import { biLogger } from '../../bi';
import { config } from '../../config';
import SettingsSmall from 'wix-ui-icons-common/SettingsSmall';
import { getCompleteSetupApps, filterBusinessSolutionApps, } from '@wix/manage-installed-apps';
export var ManageAppsMenuItem = composer()
    .withMarketplaceStore()
    .withTranslation()
    .withExperiments()
    .compose(function (_a) {
    var marketplaceStore = _a.marketplaceStore, t = _a.t, experiments = _a.experiments;
    var path = Path.MANAGE_APPS;
    var manageAppsLabel = t('menu.manageApps');
    var navigateTo = function () {
        biLogger.appMarketMenuNavigation({
            menu_item_label: 'manage_apps',
        });
        config.goToManageApps();
    };
    var calcPendingAppsBadge = function () {
        var hideBusinessSolutions = marketplaceStore.hideBusinessSolutionsInManageApps || false;
        var installedApps = hideBusinessSolutions
            ? filterBusinessSolutionApps(marketplaceStore.installedApps || [])
            : marketplaceStore.installedApps || [];
        var currentBundleApps = marketplaceStore.currentBundleApps || [];
        var completeSetupApps = getCompleteSetupApps(installedApps, currentBundleApps, marketplaceStore.siteIsPremium, experiments);
        var completeSetupCount = completeSetupApps && completeSetupApps.length;
        return completeSetupCount || 0;
    };
    var pendingAppsCount = calcPendingAppsBadge();
    var pendingAppsCounterBadge = pendingAppsCount > 0 ? (React.createElement(CounterBadge, { skin: "danger" }, pendingAppsCount)) : null;
    var settingIcon = React.cloneElement(React.createElement(SettingsSmall, null), {
        className: s.menuItemIcon,
    });
    return (React.createElement(Box, { dataHook: 'manage-apps-menu-item', direction: "vertical", alignContent: "space-between" },
        React.createElement(SidebarDivider, { fullWidth: true }),
        React.createElement(SidebarSectionItem, { suffix: pendingAppsCounterBadge, dataHook: 'manage-apps-section-item', onClick: navigateTo, className: s.menuItem },
            React.createElement(AppMarketLink, { to: path, className: s.menuItemLink },
                React.createElement(Box, { verticalAlign: "middle", gap: "10px" },
                    settingIcon,
                    manageAppsLabel))),
        React.createElement(SidebarDivider, { fullWidth: true })));
});
//# sourceMappingURL=manage-apps-menu-item.js.map